import React from 'react'
import { Card, Tag, Typography } from 'antd'
import { getAvailableServices } from '../utils'
import { useSelector } from 'react-redux'
import { hexToRGBA } from '../../../../lib/utils'

const { Title } = Typography

const ServiceSelection = ({ service, setService, selectedMedicalProfessional, token }) => {
  const servicesState = useSelector((state) => state.services.data)
  const availableServices = getAvailableServices(servicesState, selectedMedicalProfessional)

  return (
    <Card
      title='Service Type'
      bordered={false}
      size='small'
      style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}
      headStyle={{ padding: '6px 10px', fontSize: '13px' }}
      bodyStyle={{ padding: '8px 10px' }}
    >
      <div className='service-selection'>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {availableServices.map((serviceOption) => {
            const isSelected = service && service._id === serviceOption._id

            return (
              <Card
                key={serviceOption._id}
                size='small'
                style={{
                  width: 'calc(33.33% - 6px)',
                  cursor: 'pointer',
                  textAlign: 'center',
                  border: `2px solid ${isSelected ? token.colorPrimary : hexToRGBA(token.colorBorder, 0.2)}`,
                  background: isSelected ? hexToRGBA(token.colorPrimary, 0.08) : '#ffffff',
                  boxShadow: isSelected ? '0 4px 20px rgba(24, 144, 255, 0.15)' : '0 2px 8px rgba(0,0,0,0.06)',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
                bodyStyle={{ padding: '12px 8px' }}
                className='service-option-card'
                onClick={() => setService(serviceOption)}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.transform = 'translateY(-2px)'
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)'
                    e.currentTarget.style.borderColor = token.colorPrimary
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'
                    e.currentTarget.style.borderColor = hexToRGBA(token.colorBorder, 0.2)
                  }
                }}
              >
                {isSelected && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: token.colorPrimary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      color: 'white',
                      fontWeight: 'bold'
                    }}
                  >
                    ✓
                  </div>
                )}

                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: isSelected ? 600 : 500,
                    color: isSelected ? token.colorPrimary : token.colorText,
                    marginBottom: '6px'
                  }}
                >
                  {serviceOption.name}
                </div>

                <Tag
                  color={isSelected ? token.colorPrimary : 'default'}
                  style={{
                    fontSize: '11px',
                    fontWeight: 500
                  }}
                >
                  {serviceOption.timeslotInterval} min
                </Tag>
              </Card>
            )
          })}
        </div>
      </div>
    </Card>
  )
}

export default ServiceSelection
